import { Typography as MuiTypography, styled, type TypographyProps } from '@mui/material';

// Ellipsizes on wide screens; wraps on phones, where a clipped name has no non-hover way to be read.
const EllipsisTypography = styled(MuiTypography)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
  },
}));

export const Typography = ({ children, ...props }: TypographyProps) => {
  return <EllipsisTypography {...props}>{children}</EllipsisTypography>;
};
